// Utility functions and shared logic
export const formatDate = (date: Date): string => {
  return date.toLocaleDateString();
};

export const cn = (
  ...classes: (string | undefined | null | false)[]
): string => {
  return classes.filter(Boolean).join(" ");
};

// Re-export schemas
export * from "./schemas/index";

// Re-export forms (these will be used for the wizards)
export * from "./forms/index";

// Re-export other utilities
export * from "./utils";

